import React from "react";

const Svg = ({width = 492}: {width?: number} = {}) => {
  const w = 492;
  const h = 68;
  const height = (width / w) * h;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 492 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M245.518 67.5L-0.000116169 -1.57307e-05L491.036 2.71971e-05L245.518 67.5Z"
        fill="url(#paint0_linear_1199_1413)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1199_1413"
          x1="245.518"
          y1="67.5"
          x2="245.518"
          y2="-22.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F588F" />
          <stop offset="0.615385" stopColor="#0A0A0A" stopOpacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default Svg;
